import { differenceInDays, isSameWeek, startOfDay } from "date-fns";
import { EventTaskTab } from "components/_dashboard/calendar/CalendarTasksTabs";
import type { CalendarEvent } from "../../@types/sharedSchema";

export function getFilteredEventsByType(
  events: CalendarEvent[],
  type: EventTaskTab
): CalendarEvent[] {
  if (!events) return [];

  const startOfDayNowDate = startOfDay(new Date());

  let filteredEvents: CalendarEvent[] = [];

  if (type) {
    for (const event of events) {
      const isEventVisible =
        event.eventType === "meeting" ? ["today", "thisWeek", "upcoming"].includes(type) : true;

      if (!isEventVisible) continue;

      const startOfDayStartDate = startOfDay(new Date(event.start));

      const daysAgo = differenceInDays(startOfDayStartDate, startOfDayNowDate);
      const isInSameWeek = isSameWeek(startOfDayStartDate, startOfDayNowDate);

      let matched = false;

      switch (type) {
        case "today":
          matched = daysAgo === 0;
          break;
        case "thisWeek":
          matched = isInSameWeek;
          break;
        case "upcoming":
          matched = daysAgo > 0;
          break;
        case "overdue":
          matched = event.status === "pending" && daysAgo < 0;
          break;
        case "done":
          matched = event.status === "done" && daysAgo <= 90;
          break;
      }

      if (matched) filteredEvents.push(event);
    }
  } else {
    filteredEvents = events;
  }

  let sortedEvents = sortCalendarEvents(filteredEvents);

  return sortedEvents;
}

export function sortCalendarEvents(events: CalendarEvent[]): CalendarEvent[] {
  events.sort((a, b) => {
    if (a.start > b.start) return -1;
    if (a.start < b.start) return 1;
    return 0;
  });

  events.sort((a, b) => {
    if (a.status === "done" && b.status !== "done") return 1;
    if (a.status !== "done" && b.status === "done") return -1;
    return 0;
  });

  return events;
}
